
<ng-template #popContent>
    <div>
        @for (item of colors; track $index) {
            <div class="d-flex mb-2">
                <div class="border border-1 border-dark rounded square" [ngClass]="item.color"></div>
                <div class="ms-2">{{ item.description }}</div>
            </div>
        }
    </div>
</ng-template>

<div [ngbPopover]="popContent"
    triggers="mouseenter:mouseleave"
    popoverClass="color-explanation-popover"
    container="body"
    id="colorPopoverContainer">
    <i class="fas fa-info-circle"></i>
    Förklaring av färger
</div>